<template>
  <div class="checkout">
    <div class="container">
      <div class="row pb-4">
        <div class="col-lg-12">
          <h2 class="checkout-title" style="font-size: 4rem">
            Nuova presentazione
          </h2>
          <!-- End .checkout-title -->
          <ul class="nav nav-tabs nav-tabs-bg" id="tabs-1" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="tab-1-tab" data-toggle="tab" href="#tab-1" role="tab" aria-controls="tab-1"
                aria-selected="true">Presentazione</a>
            </li>
          </ul>
          <div class="tab-content tab-content-border" id="tab-content-1">
            <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab-1-tab">
              <form class="pt-4 pr-4 pl-4" @submit.prevent="new_presentation">
                <div class="row">
                  <div class="col-sm-6">
                    <label for="nome_presentazione">Titolo *</label>
                    <input type="text" class="form-control" name="nome" id="nome_presentazione"
                      placeholder="Scrivi il titolo della presentazione " v-model="form.name" required />
                    <div class="alert alert-danger" v-if="errors.name">
                      {{ errors.name[0] }}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="autore">Autore *</label>
                    <input type="text" class="form-control" v-model="form.author" name="autore" id="autore"
                      placeholder="Scrivi l' autore" required />
                    <div class="alert alert-danger" v-if="errors.author">
                      {{ errors.author[0] }}
                    </div>
                  </div>
                  <!-- End .col-sm-6 -->


                  <div class="col-md-6">
                    <label for="patologia_edit" class="form-label">Patologia
                    </label>
                    <select class="form-control" id="patologia_edit" v-model="form.patology_id" name="id_patologia">
                      <option disabled selected value="0">
                        Seleziona la patologia
                      </option>

                      <option v-for="patology in patologies" :key="patology.id" :value="patology.id">
                        {{ patology.name }}
                      </option>
                    </select>
                    <div class="alert alert-danger" v-if="errors.patology_id">
                      {{ errors.patology_id[0] }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label for="distretto_anatomico" class="form-label">Distretto Anatomico</label>
                    <select class="form-control" id="distretto_anatomico" name="id_distretto"
                      v-model="form.anatomical_district_id">
                      <option value="0" disabled selected>
                        Seleziona il distretto anatomico
                      </option>
                      <option v-for="anatomical in anatomicalDistrict" :key="anatomical.id" :value="anatomical.id">
                        {{ anatomical.name }}
                      </option>
                    </select>
                    <div class="alert alert-danger" v-if="errors.anatomical_district_id">
                      {{ errors.anatomical_district_id[0] }}
                    </div>
                  </div>

                  <div class="col-md-12">
                    <label for="descrizione">Descrizione </label>
                    <textarea class="form-control" id="descrizione" rows="3" v-model="form.description"
                      name="descrizione" placeholder="Descrizione dell'articolo"></textarea>

                    <div class="alert alert-danger" v-if="errors.description">
                      {{ errors.description[0] }}
                    </div>
                  </div>

                  <h6 class="text-center">Caricamento allegati</h6>
                  <div class="input-group mb-3">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" name="files[]" ref="fileInput"
                        @change="handleFileUpload" id="fileInput" aria-describedby="inputGroupFileAddon01" multiple />
                      <label class="custom-file-label text-center" for="fileInput" id="labelsfiles">{{ nameFiles
                        }}</label>
                    </div>
                  </div>
                </div>
                <!-- End .row -->

                <div class="row flex-column pb-2 pl-2 pr-2">
                  <div class="flex-row">
                    <button type="submit" class="btn btn-primary float-right">
                      Pubblica la presentazione<i class="las la-save"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End .container -->
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import httpservices from "@/services/httpservices.js";
import router from "@/router";
import { useAuth } from "@/stores/auth.js";
export default {
  name: "CreatePresentation",
  props: {},
  data() {
    return {
      libraries: [],
      permission: {},
      patologies: [],
      attachments: [],
      nameFiles: "Scegli i file (MAX 1 GIGA)",
      anatomicalDistrict: [],
      form: {
        name: "",
        author: "",
        patology_id: 0,
        anatomical_district_id: 0,
        description: "",
      },
      errors: [],
    };
  },
  mounted() { },
  created() {

    this.fetchPatology();
    this.fetchAtomicalDistrict();
  },
  methods: {

    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistrict = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async new_presentation() {
      await httpauth
        .post("/presentations/store", this.form)
        .then((response) => {
          if (response.data.status)
          {
            localStorage.setItem(
              "successMessagePresentation",
              response.data.message
            );
            if (this.attachments.length > 0)
            {
              this.uploadFiles(response.data.data);
            } else
            {
              router.push("/presentation");
            }
          }
        })
        .catch((error) => {
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          console.log(error);
        });
    },
    async uploadFiles(id) {
      await httpservices
        .uploadAttachments(this.attachments, id, "activity", 1, 1)
        .then(() => {
          this.nameFiles = "Scegli i file (MAX 1 GIGA)";
          router.push("/library");
        })
        .catch((error) => {
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          console.log(error);
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = Array.from(event.target.files);
      const totalSize = files.reduce(
        (accumulator, file) => accumulator + file.size,
        0
      );
      const validFiles = [];
      if (totalSize <= maxSize)
      {
        const allowedTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.ms-office",
          "video/mp4",
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        Array.from(files).forEach((file) => {
          // Esegui l'azione desiderata su ogni file
          if (
            !allowedTypes.includes(file.type) ||
            !httpservices.checkDicom(file)
          )
          {
            alert(
              "Per favore seleziona un file valido (PDF/DOC/DOCX/JPEG/JPG/PNG/MP4/DCM)."
            );
            this;
            return;
          }
          validFiles.push(file.name);
        });

        this.attachments = files;
        this.nameFiles = validFiles.join(", ");
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
  },
};
</script>